import styled from 'styled-components';
import { transparentize } from 'polished';
import { zoomIn } from '../../styles';

export const ConfirmationTitle = styled.span`
  display: block;
  margin-bottom: 8px;
  line-height: 24px;
  font-weight: ${props => props.theme.fontWeightMedium};
  font-size: 18px;
`;

export const ConfirmationMessage = styled.span`
  display: block;
  margin-bottom: 3px;
  line-height: 18px;
  font-weight: ${props => props.theme.fontWeighLight};
  font-size: 14px;
  color: ${transparentize(0.5, '#000')};
`;

export const ConfirmationDialog = styled.div`
  width: 400px;
  padding: 20px;
  background-color: #fff;
  box-shadow: 0 2px 4px ${transparentize(0.9, '#000')};
  line-height: 20px;
  font-size: 15px;
  animation: ${zoomIn} 0.3s ease-out;
`;

export const Confirmation = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding-top: 20vh;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 6003;
  width: 100vw;
  height: 100vh;
  background-color: ${transparentize(0.4, '#000')};
`;
